<!-- 显示库存的表格 -->
<template>
  <Table
    style="margin-bottom: 20px"
    ref="tableRef"
    :showIndex="true"
    :data="tableData"
    :columns="tableColumns"
    :loading="loading"
    :total="tableTotal"
    :isLineSearch="true"
    :isSelect="true"
    :sortable="true"
    rowKey="productInventoryId"
    height="calc(100vh - 240px)"
    :searchAttrName="['productName', 'productType', 'classification']"
    :isCreateSearch="false"
    :customParamsFun="() => ({ warehouse: data.warehouseId })"
    :showPagination="false"
    :showSearchComponents="false"
    tableName="inventoryStatistics"
    @onSearch="handleSearch"
  >
    <template #henderExtend>
      <div class="ml20">
        <el-date-picker
          v-model="mouthrangeData"
          type="monthrange"
          unlink-panels
          range-separator="-"
          format="YYYY-MM"
          value-format="YYYY-MM"
          start-placeholder="期初"
          end-placeholder="期末"
        />
        <el-button class="ml10" type="primary" @click="handleSearch"
          >查询</el-button
        >
      </div>
    </template>
  </Table>
</template>

<script setup>
import Table from "@/components/Element/Table";
import { onMounted, ref, watch } from "vue";
import { getCustomTableCols } from "@/tableColumn";
import { selectInventoryReport } from "@/api/warehouse/inventory";
import { getMonth } from "@/utils/fangerUtils";

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  activeName: {
    type: String,
    default: "",
  },
});

const mouthrangeData = ref([getMonth("s", -1), getMonth("e", -1)]);
const tableRef = ref(null);
const tableData = ref([]);
const loading = ref(false);
const tableTotal = ref(0);

const handleSearch = () => {
  const [start, end] = mouthrangeData.value;
  const formattedStart = start.substring(0, 7) + "-01 00:00:00";

  const endYearMonth = end.substring(0, 7);
  const endDate = new Date(endYearMonth);
  endDate.setMonth(endDate.getMonth() + 1);
  endDate.setDate(0);
  const lastDay = endDate.getDate();
  const formattedEnd = `${endYearMonth}-${lastDay
    .toString()
    .padStart(2, "0")} 23:59:59`;
  const param = {
    warehouseId: props.data.warehouseId,
    startTime: formattedStart,
    endTime: formattedEnd,
  };
  loading.value = true;
  selectInventoryReport(param)
    .then((res) => {
      tableData.value = res.data;
      tableTotal.value = res?.pageParam?.totleInfo
        ? res.pageParam.totleInfo
        : 0;
    })
    .catch((err) => {})
    .finally(() => {
      loading.value = false;
    });
};

const tableColumns = getCustomTableCols([
  "productName",
  "productType",
  "classification",
  "supplier",
  "supplierModel",
  "internalModel",
  "usageType",
  "openingInventory",
  "endingInventory",
  "inboundQuantity",
  "outboundQuantity",
  "realtimeInventory",
]);

onMounted(() => {
  watch(
    () => props.activeName,
    (newVal) => {
      if (newVal === props.data.warehouseId) {
        // 更新数据
        tableRef.value && tableRef.value.onSearch();
      }
    },
    {
      immediate: true,
    },
  );
});
</script>

<style lang="scss" scoped></style>
